module.exports = __webpack_public_path__ + "img/finance.bf1663f6.png";